export default __webpack_public_path__ + "static/mondayCrmImage-66a9b7e6c44efdcfbe39188faa5219bf.webp";